import { Component, Input } from '@angular/core';
import { NewsfeedResult, selectNewsfeedResultId } from '@planone/bau365/data-access-newsfeed';

@Component({
  selector: 'bau365-section-result-list',
  templateUrl: './section-result-list.component.html',
  styleUrls: ['./section-result-list.component.scss'],
})
export class SectionResultListComponent {
  @Input() results: NewsfeedResult[] | null = null;
  @Input() size: string | undefined | null;
  @Input() insightsId: string | undefined | null;

  identifyNewsfeedResult(_index: number, result: NewsfeedResult) {
    return selectNewsfeedResultId(result);
  }
}
